import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { React } from 'libs/react';
import './Switch.scss';
/**
 * @component Switch
 * @since 1.0.0
 */
export function Switch(props) {
    const { style, required, disabled, stopPropagation } = Object.assign({ style: 'normal' }, props);
    const [active, setActive] = useState(props.active || false);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick(e) {
        if (disabled) {
            return;
        }
        if (stopPropagation) {
            e.stopPropagation();
        }
        if (props.onClick) {
            props.onClick(active);
        }
        setActive((active) => !active);
    }
    useWatch(() => {
        if (props.onChange) {
            props.onChange(active);
        }
    }, [active]);
    useWatch(() => {
        var _a;
        setActive((_a = props.active) !== null && _a !== void 0 ? _a : false);
    }, [props.active]);
    const className = classNames('switch', 'switch--' + style, { 'switch--is-active': active }, { 'switch--is-required': required }, { 'switch--is-disabled': disabled }, props.className);
    return (React.createElement("div", { className: className, onClick: onClick },
        React.createElement("div", { className: "switch-track" }),
        React.createElement("div", { className: "switch-thumb" })));
}
